const DEFAULT_PAY_URL = "https://ecg.test.upc.ua/rbrs/pay";
const DEFAULT_MERCHANT_ID = "1731407";
const DEFAULT_TERMINAL_ID = "E7051407";
const DEFAULT_CURRENCY_ID = 941;
const DEFAULT_LOCALE = "EN";
const DEFAULT_VERSION = 1;

const createHiddenInput = (name, value) => {
  const input = document.createElement("input");
  input.type = "hidden";
  input.name = name;
  input.value = value;
  return input;
};

export const redirectToRaiffeisenPayment = (
  paymentData,
  { includeTokenFields = true, includeNotifyUrl = true } = {}
) => {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = paymentData?.payUrl || DEFAULT_PAY_URL;

  form.appendChild(
    createHiddenInput("MerchantID", paymentData?.merchantId || DEFAULT_MERCHANT_ID)
  );
  form.appendChild(
    createHiddenInput("TerminalID", paymentData?.terminalId || DEFAULT_TERMINAL_ID)
  );
  form.appendChild(createHiddenInput("TotalAmount", paymentData?.price));
  form.appendChild(
    createHiddenInput("Currency", paymentData?.currencyId || DEFAULT_CURRENCY_ID)
  );
  form.appendChild(
    createHiddenInput("locale", paymentData?.locale || DEFAULT_LOCALE)
  );
  form.appendChild(createHiddenInput("PurchaseTime", paymentData?.time));
  form.appendChild(createHiddenInput("OrderID", paymentData?.orderNumber));
  form.appendChild(
    createHiddenInput("Version", paymentData?.version || DEFAULT_VERSION)
  );

  if (includeTokenFields) {
    const shouldGenerateToken = paymentData?.generateToken !== false;
    form.appendChild(
      createHiddenInput("GenerateToken", shouldGenerateToken ? "true" : "false")
    );
  }

  if (includeNotifyUrl && paymentData?.notifyUrl) {
    form.appendChild(createHiddenInput("URL", paymentData.notifyUrl));
  }

  form.appendChild(createHiddenInput("Signature", paymentData?.signature));
  document.body.appendChild(form);
  form.submit();
};
